var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showForm)?_c('InternalForm',{attrs:{"data":_vm.row},on:{"close-form":function($event){return _vm.setFormShow(false, $event)}}}):_vm._e(),(!_vm.showForm)?_c('InternalList',{on:{"show-form":function($event){return _vm.setFormShow(true)},"edit-template":_vm.setData,"delete-template":_vm.setDelete}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }